exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echart07{font-size:10px;font-weight:700;width:100%}", ""]);

// exports
